
/*
 * Copyright (C) 2015 ICOS Group, Newcastle University.  All rights reserved.
 * Contact:  James Alastair McLaughlin <j.a.mclaughlin@ncl.ac.uk>
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions
 * are met:
 *  
 * 1. Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  
 * 2. Redistributions in binary form must reproduce the above copyright
 *    notice, this list of conditions and the following disclaimer in the
 *    documentation and/or other materials provided with the distribution.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE AUTHOR AND CONTRIBUTORS ``AS IS'' AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED.  IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS
 * OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
 * HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
 * SUCH DAMAGE.
 */

"use strict";

var URI = require('urijs'),
    Identified = require('./Identified'),
    util = require('./util');

/**
 * Class to represent an SBOL2 Range location.
 */
class Range extends Identified
{
    constructor(sbolDocument, uri) {

        super(sbolDocument, uri);

        this._start = 0;
        this._end = 0;
        this._orientation = URI('');
        this._sequence = URI('');
    }

    /**
     * Set the start property for this Range.
     * @param {Integer} [start]
     */
    set start(start) {
        this._start = start;
    }

    /**
     * Retrieve the start property for this Range.
     * @returns {Integer}
     */
    get start() {
        return this._start;
    }

    /**
     * Set the end property for this Range.
     * @param {Integer} [end]
     */
    set end(end) {
        this._end = end;
    }

    /**
     * Retrieve the end property for this Range.
     * @returns {Integer}
     */
    get end() {
        return this._end;
    }

    /**
     * Set the orientation property for this Range.
     * @param {string|URI} [orientation]
     */
    set orientation(orientation) {
        this._orientation = util.uriOrObject(orientation);
    }

    /**
     * Retrieve the orientation property for this Range.
     * @returns {URI}
     */
    get orientation() {
        return this._orientation;
    }

    /**
     * Set the Sequence for this location.
     * @param {string|URI|Sequence} [sequence]
     */
    set sequence(sequence) {
        this._sequence = util.uriOrObject(sequence);
    }

    /**
     * Retrieve the Sequence for this location.  Returns either a
     * URI or a Sequence, depending on whether the URI has been
     * resolved by link().
     *
     * @returns {URI|Sequence}
     */
    get sequence() {
        return this._sequence;
    }

    link() {
        this._sequence = this._sbolDocument.lookupURI(this._sequence);
    }
}

module.exports = Range;


